import { render, staticRenderFns } from "./umyBasicList.vue?vue&type=template&id=29661aea&scoped=true&"
import script from "./umyBasicList.vue?vue&type=script&lang=js&"
export * from "./umyBasicList.vue?vue&type=script&lang=js&"
import style0 from "./umyBasicList.vue?vue&type=style&index=0&id=29661aea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29661aea",
  null
  
)

export default component.exports